import { defineStore } from 'pinia'

export const useUserListStore = defineStore('userList', {
  state: () => ({
    so: '',
    users: [],
    infotainments: [],
    page: 1,
    hasMore: false,
    restrict: null,
  }),
  actions: {
    clear() {
      this.$reset()
    },

    hasUserId(id) {
      return this.users.some((u) => u.id === id)
    },
  },
})
